// extracted by mini-css-extract-plugin
export var editInput = "_k9-0";
export var editInputCompact = "_k9-2";
export var editInputLarge = "_k9-1";
export var editInputSmall = "_k9-3";